// Reverse of Unity TextSanitizer.SanitizeTextForDatabase
// Based on provided C# implementation: replaces specific placeholders back to symbols where reversible.

const SIMPLE_TOKENS = [
    ['[quote]', '"'],
    ['[apostrophe]', "'"],
    ['[backslash]', '\\'],
];

// Tokens that represent non-rendering/control behavior → drop them
const DROP_TOKENS = [
    '[zero-width]',
    '[zero-width-no-break]',
    '[rtl-override]',
    '[rtl-pop]',
    '[ltr-override]'
];

// Map category placeholders to representative glyphs for readability
const EMOJI_PLACEHOLDER_MAP = new Map([
    ['[face-emoji]', '😀'],
    ['[symbol-emoji]', '🔣'],
    ['[transport-emoji]', '🚗'],
    ['[flag-emoji]', '🏳️'],
    ['[misc-symbol]', '✳️'],
    ['[dingbats]', '✴️'],
    ['[supplemental-emoji]', '🤖'],
    ['[extended-emoji]', '🧩'],
    ['[playing-card]', '🃏'],
    ['[enclosed-emoji]', '🅰️'],
    ['[geometric-emoji]', '⬛'],
    ['[supplemental-arrows]', '➡️'],
    ['[mahjong]', '🀄'],
    ['[enclosed-char]', 'Ⓜ️'],
    ['[chess-symbol]', '♟️'],
    ['[alchemical-symbol]', '⚗️'],
    ['[legacy-computing-symbol]', '🖥️'],
    ['[tag]', '🏷️'],
    ['[private-use]', ''],
    ['[variation-selector]', ''],
    ['[combining-symbol]', ''],
]);

const CONTROL_TOKEN_REGEX = /\[control-([0-9A-Fa-f]{4})\]/g;

export function desanitizeText(value) {
    if (value == null) return '';
    let text = String(value);

    // Restore simple tokens
    for (const [token, symbol] of SIMPLE_TOKENS) {
        text = text.split(token).join(symbol);
    }

    // Drop behavior/control placeholders
    for (const token of DROP_TOKENS) {
        text = text.split(token).join('');
    }

    // CONTROL-XXXX → remove (or replace with unicode if you want to attempt)
    text = text.replace(CONTROL_TOKEN_REGEX, '');

    // Replace category placeholders with representative glyphs
    for (const [token, glyph] of EMOJI_PLACEHOLDER_MAP.entries()) {
        if (!token) continue;
        text = text.split(token).join(glyph);
    }

    return text;
}

export default desanitizeText;


